/** Kampfmittelauskunft product id. */
export const KampfmittelauskunftProductId = 4258 // this product belongs to the Authorities Documents category

/**
 * The same product addressed by `sfdc_product_code`, for flows that only have
 * the code (PF v2's catalogue never carries a numeric product id). Confirmed
 * against the dev product table: `products.product_id = 4258` →
 * `sfdc_product_code = 'KAMPFMITTELAUSKUNFT'`.
 *
 * The bridge form is matched too: the v2 catalogue still emits `p_<id>` for
 * products with no real code (`ProductCatalogV2Service.legacyProductCode`), and
 * ISSUE-2944 is what retires it.
 */
export const KampfmittelauskunftProductCodes: ReadonlySet<string> = new Set([
  'KAMPFMITTELAUSKUNFT',
  `p_${KampfmittelauskunftProductId}`,
])
